module.exports = __webpack_public_path__ + "img/card-back.330ad928.png";